import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { red } from "@material-ui/core/colors";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import moment from "moment";
import { Link } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import CircularProgress from "@material-ui/core/CircularProgress";

import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import ProjectFiles from "./ProjectFiles";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
// import { getProjectFiles } from '../../store/actions/ProjectActions';
import {
  addNotification,
  addAdminNotification,
} from "../../store/actions/notificationActions";
import Loader from "../../components/custom/loader";
import { getFileName, checkA } from "../../constant";
import Tasks from "./tasks/Tasks";
import { getCollection } from "../../constant";
import EditIcon from "@material-ui/icons/Edit";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import Delete from "@material-ui/icons/Delete";
import { Timer } from "../custom/Timer";
import { Grid } from "@material-ui/core";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import GetAppIcon from "@material-ui/icons/GetApp";
import DownloadLink from "../custom/DownloadLink";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    // width: '90%', margin: 'auto', maxWidth: 1200,
  },
  // avatar: {
  //   backgroundColor: red[500],
  // },
  title: {
    padding: 20,
    backgroud: "#fff",
  },
  tabContent: {
    background: "#eee",
  },
  files: {
    textAlign: "center",
  },
  file: {
    borderRadius: 20,
    backgroundColor: "#999",
    background: "linear-gradient(to bottom, #bbb, #ddd)",
    overflow: "hidden",
    width: 200,
    height: 200,
    position: "relative",
    display: "inline-block",
    zIndex: 10,
    fontSize: 10,
    margin: 5,
    padding: 5,
  },
});

class ProjectDetails extends React.Component {
  state = {
    value: 0,
  };

  a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  getFiles = () => {
    const { firestore, id, profile } = this.props;

    let coll = getCollection(profile, "files");
    if (coll != "Jassu") {
      firestore
        .collection(coll)
        .where("parentId", "==", id)
        .get()
        .then(
          (querySnapshot) => {
            const files = querySnapshot.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
              sortDate: parseInt(
                moment(doc.data().timeCreated).format("YMMDDhhmmss")
              ),
            }));

            files.sort((a, b) => {
              return b.sortDate - a.sortDate;
            });

            console.log("Jassu files Success : ", files);

            this.setState({ files });
          },
          (err) => {
            console.error("Jassu files err : ", err);
          }
        );
    }
  };

  async componentDidMount() {
    const { tabId } = this.props;

    setTimeout(() => {
      this.getFiles();
    }, 2000);
    if (tabId) {
      this.setState({ value: parseInt(tabId) });
    }
  }

  updateProject = (reopen = false) => {
    let msg = "Are you sure, you want to complete this project?";
    if (reopen) msg = "Are you sure, you want to reopen this project?";

    let con = window.confirm(msg);

    if (con) {
      const { firestore, id, profile, project } = this.props;

      let data = {
        updatedAt: new Date(),
        updatedBy: profile.id,
        updatedByUserName: profile.displayName,
      };
      if (reopen) {
        data = { ...data, complete: false, reopen: true };
      } else {
        data = { ...data, complete: true };
      }

      firestore
        .update(
          { collection: getCollection(profile, "projects"), doc: id },
          data
        )
        .then(
          () => {
            const notification = {
              from: profile.id,
              projectId: id,
              projectTitle: project.title,
              title: `Project(${project.title}) has been ${
                reopen ? "Reopned" : "Closed"
              } by ${profile.displayName}`,
              fromName: profile.displayName,
              type: reopen ? "ProjectReoepn" : "ProjectClosed",
            };

            project.assignee.forEach((user) => {
              addNotification(
                firestore,
                {
                  ...notification,
                  to: user.id,
                },
                profile
              );
            });

            addAdminNotification(firestore, notification, profile);
          },
          (err) => {
            alert(err.message);
          }
        );
    }
  };

  deleteProject = () => {
    let con = window.confirm("Are you sure, you want to delete this project?");
    if (con) {
      const { firestore, id, profile, history } = this.props;

      firestore
        .collection(getCollection(profile, "projects"))
        .doc(id)
        .delete()
        .then(
          () => {
            history.push("/projects");
          },
          (err) => {}
        );
    }
  };

  render() {
    const { project, classes, projectFiles, profile, firestore } = this.props;
    const { value, files } = this.state;

    console.log("projectFiles : ", projectFiles);

    if (!project || (project && !project.createdAt)) {
      return (
        <Typography component="h3" gutterBottom align="center">
          <CircularProgress align="center" />
        </Typography>
      );
    }
    const { id, title, content, createdAt, complete } = project;

    return (
      <div className={classes.root}>
        <div className={classes.title}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </div>

        <AppBar position="static">
          <Tabs
            value={value}
            onChange={this.handleChange}
            aria-label="simple tabs example"
          >
            <Tab label="Details" {...this.a11yProps(0)} />
            {/* <Tab label="Files" {...this.a11yProps(1)} /> */}
            <Tab label="Files" {...this.a11yProps(2)} />
            <Tab label="Tasks" {...this.a11yProps(2)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} className={classes.tabContent}>
          {checkA(profile) && !complete && (
            <Link to={"/edit-project/" + id} key={id}>
              <Button
                style={{ float: "right", margin: "10px 22px -10px 0" }}
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
              >
                Edit Project{" "}
              </Button>
            </Link>
          )}

          {!complete && (
            <Button
              onClick={() => {
                this.updateProject(false);
              }}
              style={{ float: "right", margin: "10px 20px -10px 0" }}
              variant="contained"
              color="secondary"
              startIcon={<DoneAllIcon />}
            >
              Complete Project{" "}
            </Button>
          )}

          {checkA(profile) && (
            <Button
              onClick={this.deleteProject}
              style={{ float: "right", margin: "10px 20px -10px 0" }}
              variant="contained"
              color="secondary"
              startIcon={<Delete />}
            >
              Delete Project{" "}
            </Button>
          )}

          {complete && checkA(profile) && (
            <Button
              onClick={() => {
                this.updateProject(true);
              }}
              style={{ float: "right", margin: "10px 20px -10px 0" }}
              variant="contained"
              color="secondary"
              // startIcon={<DoneAllIcon />}
            >
              Reopen Project{" "}
            </Button>
          )}

          <Timer {...project} css={{ position: "static", marginLeft: 15 }} />

          <div style={{ clear: "both", height: 1, width: "100%" }}></div>

          <Card style={{ margin: 20 }}>
            {/* <CardHeader style={{ padding: 10 }}
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>A</Avatar>
              }
              title={title}
              subheader={createdAt ? moment(createdAt.toDate()).calendar() : null}
            /> */}
            <CardContent style={{ padding: 10 }}>
              {/* <IconButton aria-label="share">
            <EditIcon />
          </IconButton> */}

              <div>
                <strong>Project Manager</strong> : {project.manager.displayName}
              </div>

              <div>
                <strong>Project assignee</strong> :
                {project.assignee.map((user, i) => {
                  return (
                    <span key={user.id}>
                      {" "}
                      {i != 0 && ","} {user.displayName}
                    </span>
                  );
                })}
              </div>

              <br />
              <p>
                <strong>Project Description</strong>
              </p>
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
            </CardContent>
          </Card>
        </TabPanel>
        <TabPanel value={value} index={1} className={classes.tabContent}>
          <Grid container>
            <Grid item xs={12} md={6}>
              {files ? (
                files.length > 0 ? (
                  <TableContainer
                    style={{ marginTop: 20, marginBottom: 20 }}
                    component={Paper}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Name</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Created By</TableCell>
                          <TableCell align="right">Created At</TableCell>
                          <TableCell align="right">Open</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {files.map(
                          ({
                            id,
                            name,
                            userName,
                            contentType,
                            timeCreated,
                            url,
                          }) => {
                            return (
                              <TableRow key={id}>
                                <TableCell style={{ wordBreak: "break-word" }}>
                                  {name}
                                </TableCell>
                                <TableCell>{contentType}</TableCell>
                                <TableCell>{userName}</TableCell>
                                <TableCell align="right">
                                  {moment(timeCreated).format("DD-MM-Y")}
                                </TableCell>
                                <TableCell align="right">
                                  <DownloadLink to={url}>
                                    <IconButton>
                                      <GetAppIcon />
                                    </IconButton>
                                  </DownloadLink>
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography variant="h5">
                    There are no file(s) to show
                  </Typography>
                )
              ) : null}
            </Grid>
            <Grid item xs={12} md={6}>
              <ProjectFiles
                newFileUploaded={this.getFiles}
                projectId={project.id}
                profile={profile}
                firestore={firestore}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2} className={classes.tabContent}>
          <Tasks project={project} />
        </TabPanel>
      </div>
    );
  }
}

const mapSateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const tabId = ownProps.match.params.tabId;
  const projects =
    state.firestore.data[getCollection(state.firebase.profile, "projects")];
  const project = projects ? projects[id] : null;

  // const files = state.firestore.ordered[getCollection(state.firebase.profile, 'files')] || [];

  // files.sort((a, b) => {
  //   return b.createdAt - a.createdAt;
  // });

  return {
    project: { ...project, id },
    auth: state.firebase.auth,
    // projectFiles: state.project.projectFiles,
    // files,
    profile: state.firebase.profile,
    id,
    tabId,
  };
};

export default compose(
  connect(mapSateToProps),
  firestoreConnect((props) => {
    if (props.id)
      return [
        {
          collection: getCollection(props.profile, "projects"),
          // orderBy: ['createdAt', 'desc'],
          doc: props.id,
        },
        // {
        //   collection: getCollection(props.profile, 'files'),
        //   where: ['parentId', '==', props.id]
        // },
      ];
  })
)(withStyles(styles)(ProjectDetails));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
